import styled from 'styled-components';

const Right = styled.div`
  flex: 1;
  margin-left: ${({ theme }) => theme.spacing(4)};
  text-align: right;
  font-size: 15px;
  line-height: 20px;
`;

export default Right;
